import saleActions from "./saleActions";

const allSaleActions = {
  saleActions,
};

export default allSaleActions;
